// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1853":"c5904956","2239":"89221bd1","4250":"553f425c","4273":"89221bd1","7472":"89221bd1","8145":"8bf70297","9512":"cd3ec766"}[chunkId] + ".chunk.css";
};